// https://stackoverflow.com/a/48521127/4204919
import {GameColor} from '../GameColor'

import {PIXI} from '@colonist/pixi'

export class ProgressBarView extends PIXI.Graphics {
    private _fillColor: number = GameColor.getColorHexValue(GameColor.Color.GreenDark)
    private _emptyColor: number = GameColor.getColorHexValue(GameColor.Color.White)
    private _borderColor: number = GameColor.getColorHexValue(GameColor.Color.Gray0)
    private _cornerRadius: number = 0
    readonly size: {width: number, height: number}
    private _percentage: number = 0

    constructor(width: number, height: number, container: PIXI.Container, fillColor?: number, borderColor?: number, cornerRadius?: number) {
        super()

        this.size = {width: width, height: height}
        container.addChild(this)
        if(fillColor != undefined) this.fillColor = fillColor
        if(borderColor != undefined) this.borderColor = borderColor
        if(cornerRadius != undefined) this.cornerRadius = cornerRadius

        this.draw()
    }

    draw() {
        this.clear()

        let percentage = this.percentage
        if(percentage < 0) percentage = 0
        if(percentage > 1) percentage = 1

        this.lineStyle(1, this.borderColor, 1, 1)
        this.beginFill(this.emptyColor)
        if(this.cornerRadius == 0) this.drawRect(0, 0, this.size.width, this.size.height)
        else this.drawRoundedRect(0, 0, this.size.width, this.size.height, this.cornerRadius)
        this.endFill()

        this.lineStyle(0)
        this.beginFill(this.fillColor)
        if(this.cornerRadius == 0) this.drawRect(0, 0, this.size.width * percentage, this.size.height)
        else this.drawRoundedRect(0, 0, this.size.width * percentage, this.size.height, this.cornerRadius)
        this.endFill()
    }

    get percentage(): number {
        return this._percentage
    }

    set percentage(value: number) {
        this._percentage = value
        this.draw()
    }

    get fillColor(): number {
        return this._fillColor
    }

    set fillColor(value: number) {
        this._fillColor = value
        this.draw()
    }

    get emptyColor(): number {
        return this._emptyColor
    }

    set emptyColor(value: number) {
        this._emptyColor = value
        this.draw()
    }

    get borderColor(): number {
        return this._borderColor
    }

    set borderColor(value: number) {
        this._borderColor = value
        this.draw()
    }

    get cornerRadius(): number {
        return this._cornerRadius
    }

    set cornerRadius(value: number) {
        this._cornerRadius = value
        this.draw()
    }
}
